import { PlusIcon } from "@phosphor-icons/react/dist/ssr/Plus";

import type { ComponentProps } from "react";

type Props = {
  onClick: ComponentProps<"button">["onClick"];
};

export default function AddButton({ onClick }: Props) {
  return (
    <button
      aria-label="add to cart"
      className="block cursor-pointer border-0 bg-transparent p-[0.1rem] text-green-600"
      data-testid="checkout-add-button"
      onClick={onClick}
      title="add to cart"
    >
      <PlusIcon size={24} weight="bold" />
    </button>
  );
}
